import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { spinnerOff, spinnerOn } from '../../components/Spinner';
import {
  deleteFMPTracker,
  deleteProjectAsset,
  post,
  get,
  updateDatatrackerProject,
} from '../../api';

import IpsFMPProjectGrid from '../../components/ProjectsGrid/IpsFMPProjectGrid';

import IpsFMPProjectList from 'components/ProjectsList/IpsFMPProjectList';
import IPSFMPViewType from 'components/ViewType/IPSFMPViewType';
import ConfirmDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/ConfirmDialogBox';
import {
  directToProject,
  handleStartFMPTracker,
  startProjectPendingFMPProject,
} from '../../utils/Dashboard';
import DeleteConfirmationDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/DeleteConfirmationDialog';
import EditProjectDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/EditProjectDialog';
import DuplicateBPIDDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/DuplicateBPIDDialog';
import MatchProjectsDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/MatchProjectsDialog';
import SpinnerNew from "../../components/Spinner/SpinnerNew";
import allData from './allfmp.json';

export default withRouter(function FMPTrackerAll(props) {
  const {
    context,
    history,
    cardview,
    onViewTypeChange,
    projectList,
    ipsStations,
  } = props;
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [reactivateCurrentProject, setReactivateCurrentProject] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reActiveOrDelete, setReactiveOrDelete] = useState('');
  const [deleteCurrentProject, setDeleteCurrentProject] = useState({});
  const [confirmDialogDetails, setConfirmDialogDetails] = useState({});
  const [duplicateProjects, setDuplicateProjects] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  
  const [openDuplicateModal, setOpenDuplicateModal] = useState(false);
  const [confirmationDetails, setConfirmationDetails] = useState({});
  const [isBPIDClear, setIsBPIDClear] = useState(false);
  async function getProjects() {
    if (projects && projects.length < 1) {
    spinnerOn();
    setIsLoading(true);

    const result = await post(`fmpcards`, '', {});

    setProjects(result.data);
    spinnerOff();
    setIsLoading(false);
    }
  }

  useEffect(() => {
    getProjects();
  }, []);
  
//TODO: Cleanup all DATA TRACKER logic that won't be utilized for FMP
  function handleDeleteBtnClick(project) {
    setConfirmDialogDetails({
      title: `Do you want to Delete ${project.stationName}?`,
      handleCancel: handleCancel,
      submitFunctionArgs: project,
      handleSubmit: deleteFmpTracker,
      confirmButtonName: 'Yes,Delete',
    });
    setIsModalOpen(true);
  }
  async function deleteFmpTracker(project) {
    await deleteFMPTracker(project);
    getProjects();
    setIsModalOpen(false);
  }

  async function reactivateProject(project) {
    let projectInfo = {
      bpid: project.bpid,
      workOrder: project.workOrder,
      stationName: project.stationName,
    };
    await updateDataTrackerProject(projectInfo);
    setIsModalOpen(false);

    directToProject(project, history, 'fmptracker_all', context);
  }


  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleMatchedDuplicateCancel = () => {
    setOpenModal(false);
  };
  const handleDeleteCancel = () => {
    setOpenDeleteModal(false);
    setOpenModal(true);
  };

  const handleDelete = () => {
    setConfirmationDetails({
      title: 'Are you sure you want to delete the following project?',
      handleCancel: handleDeleteCancel,
      handleClickOK: deleteFmpTracker,
    });

    if (selectedProject) {
      setOpenDeleteModal(true);
      setOpenModal(false);
    }
  };
  const onSelectProject = (project) => {
    setSelectedProject(project);
  };

  async function deleteFmpTracker(project) {
    const response = await deleteFMPTracker(project);
    if ((response.status = 'SUCCESS')) {
      goToProject(project);
      getProjects();
      setOpenEditModal(false);
      setOpenDeleteModal(false);
    }
  }
  const handleEditClick = () => {
    if (selectedProject) {
      setOpenEditModal(true);
      setOpenModal(false);
    }
  };

  const handleEditSave = async (data) => {
    setIsBPIDClear(false);
    const payload = {
      newBPID: data.bpid,
      newStationName: data.stationName,
      newWO: data.workOrder,
      bpid: selectedProject.bpid,
      workOrder: selectedProject.workOrder,
      stationName: selectedProject.stationName,
    };

    const result = await post(`ipsprojects/clone`, '', payload);
    if (result.status === 'SUCCESS') {
      goToProject(selectedProject);
      getProjects();
      setOpenEditModal(false);
      setOpenDeleteModal(false);
    } else if (
      result.status === 'WARNING' &&
      result.statusMsg === 'DUPLICATE_FOUND'
    ) {
      setOpenDuplicateModal(true);
      setOpenEditModal(false);
      setOpenModal(false);
    }
  };
  const handleDuplicateCancel = () => {
    setOpenDuplicateModal(false);
  };

  const handleClickOK = () => {
    setOpenEditModal(true);
    setIsBPIDClear(true);
    setOpenDuplicateModal(false);
  };

  const handleAccept = () => {
    setConfirmationDetails({
      title: 'Are you sure you want to accept the following project?',
      handleCancel: handleDeleteCancel,
      handleClickOK: acceptDataTracker,
    });
    if (selectedProject) {
      setOpenDeleteModal(true);
      setOpenModal(false);
      setOpenDuplicateModal(false);
      setOpenEditModal(false);
    }
  };
  const acceptDataTracker = async (project) => {
    const result = await post(`ipsprojects/accept`, '', project);
    if (result.status === 'SUCCESS') {
      goToProject(selectedProject);
      getProjects();
      setOpenEditModal(false);
      setOpenDeleteModal(false);
    }
  };
  const redirectToProject = () => {
    
directToProject(projects,history,'fmptracker_all',context)

  };
  const handleEditCancel = () => {
    setOpenEditModal(false);
    setOpenModal(true);
    setIsBPIDClear(false);
  };


  function goToProject(project) {
    let redirectInfo = { history, context };

    switch (project.trackerStatus) {
      case 'FMP_P':
        startProjectPendingFMPProject(
          project,
          ipsStations,
          handleStartFMPTracker,
          redirectInfo
        );
        break;
      case 'FMP_G':
        directToProject(project, history, 'fmptracker_progress', context);
        break;
      case 'FMP_B':
        directToProject(project, history, 'fmptracker_asbuilts', context);
        break;
      case 'FMP_C':
        directToProject(project, history, 'fmptracker_complete', context);
        break;
      case 'FMP_R':
        directToProject(project, history, 'fmptracker_review', context)
        break;

      default:
    }
  }

  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flewGrow: 1,
          justifyContent: 'center',
          paddingRight: '16px',
          paddingBottom: '16px',
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <SpinnerNew display={isLoading}/>
        <IPSFMPViewType
          onViewTypeChange={onViewTypeChange}
          tabView={'FMP_A'}
          
          tstatus={'FMP_A'}
        />
      </div>
      {cardview === 'cardview' ? (
        <IpsFMPProjectGrid
          projects={projectList(projects)}
          history={history}
          context={context}
          onButtonClick={goToProject}
          isLoading={isLoading}
          handleDeleteBtnClick={handleDeleteBtnClick}
          {...props}
        />
      ) : (
        <IpsFMPProjectList
          projects={projectList(projects)}
          onButtonClick={goToProject}
          {...props}
        />
      )}

      <ConfirmDialog
        show={isModalOpen}
        title={confirmDialogDetails.title}
        handleCancel={confirmDialogDetails.handleCancel}
        submitFunctionArgs={confirmDialogDetails.submitFunctionArgs}
        handleSubmit={confirmDialogDetails.handleSubmit}
        confirmButtonName={confirmDialogDetails.confirmButtonName}
        cancelButtonName={'No,Cancel'}
      />
      {selectedProject && (
        <>
          <DeleteConfirmationDialog
            title={confirmationDetails.title}
            show={openDeleteModal}
            project={selectedProject}
            handleCancel={confirmationDetails.handleCancel}
            handleClickOK={confirmationDetails.handleClickOK}
          />

          <EditProjectDialog
            show={openEditModal}
            project={selectedProject}
            stations={ipsStations}
            isBPIDClear={isBPIDClear}
            handleCancel={handleEditCancel}
            onSubmit={handleEditSave}
          />
        </>
      )}
    </Fragment>
  );
});